var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "m15.425.835-.668-.703c-.176-.176-.457-.176-.598 0L7.796 6.495 1.397.132C1.257-.044.976-.044.8.132L.132.835c-.176.14-.176.422 0 .598L7.479 8.78a.405.405 0 0 0 .598 0l7.348-7.347c.176-.176.176-.457 0-.598"
  })));
};
export default SvgChevronDown;